import { createAction, createSlice } from '@reduxjs/toolkit';

import { FolderManagerItemTypes } from '../../interfaces';

export const ASSET_MANAGER_UI_FEATURE_KEY = 'assetManagerUI';

interface SidebarItem {
  id: number;
  slug: string;
  displayName: string;
  type: FolderManagerItemTypes | null;
}

export interface AssetManagerUIState {
  newButtonState: any | null;
  searchQuery: string;
  sidebarState: {
    items: SidebarItem[] | null;
    selected: SidebarItem | null;
  };
}

//region ACTIONS
export const setNewButtonState = createAction<any>('SET_NEW_BUTTON_STATE');
export const setSidebarStateItems = createAction<SidebarItem[]>('SET_SIDEBAR_STATE_ITEMS');
export const setSidebarStateSelectedItem = createAction<{ slug: string }>('SET_SIDEBAR_STATE_SELECTED_ITEM');
export const setSearchQuery = createAction<string>('SET_SEARCH_QUERY');
//endregion

export const initialState: AssetManagerUIState = {
  newButtonState: null,
  searchQuery: '',
  sidebarState: { items: null, selected: null },
};

export const assetManagerUISlice = createSlice({
  name: ASSET_MANAGER_UI_FEATURE_KEY,
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setNewButtonState, (state, action) => {
      if (!action.payload) {
        console.error('Could not set new button state, no payload!');
        return;
      }

      state.newButtonState = action.payload;
    });
    builder.addCase(setSidebarStateItems, (state, action) => {
      if (!action.payload) {
        console.error('Could not set sidebar items, no payload!');
        return;
      }

      state.sidebarState.items = action.payload;
    });
    builder.addCase(setSearchQuery, (state, action) => {
      state.searchQuery = action?.payload || '';
    });
    builder.addCase(setSidebarStateSelectedItem, (state, action) => {
      if (!action.payload) {
        console.error('Could not set sidebar selected item, no payload!');
        return;
      }

      const { slug } = action?.payload || {};
      const foundItem = (state?.sidebarState?.items || []).find((item) => {
        return item.slug === slug;
      });

      if (!foundItem) {
        console.error('Could not set selected item. Item not found');
        return;
      }

      state.sidebarState.selected = foundItem;
    });
  },
});

export const assetManagerUIReducer = assetManagerUISlice.reducer;

export const getAssetManagerUIState = (rootState: any) => rootState[ASSET_MANAGER_UI_FEATURE_KEY];

export const assetManagerUISelectors = {
  getNewButtonState: (state: any) => getAssetManagerUIState(state).newButtonState,
  getSidebarState: (state: any) => getAssetManagerUIState(state).sidebarState,
  getSearchQuery: (state: any) => getAssetManagerUIState(state).searchQuery,
  getSidebarItemBySlug: (state: any, slug: string | undefined) => {
    if (!slug) {
      return;
    }

    const sidebarState = getAssetManagerUIState(state).sidebarState;

    if (!sidebarState?.items?.length) {
      return null;
    }

    return (sidebarState.items || []).find((item: any) => item.slug === slug) || null;
  },
};
